import {get, getByStreetCode, postByStreetCode} from "@/utils/http"

export const _selectPages = params => getByStreetCode("/dataDictionary/selectPages", params); // 列表
export const _get = params => getByStreetCode("/dataDictionary/get", params); // 删除
export const _delete = params => getByStreetCode("/dataDictionary/delete", params); // 删除
export const _updateStatus = params => getByStreetCode("/dataDictionary/updateStatus", params); // 删除
export const _edit= params =>postByStreetCode(params.id ? "/dataDictionary/update" : "/dataDictionary/save", params); // 编辑/创建
